<template>
    <div>
      <el-card class="content-card">
        <!-- Subscriptions Section -->
        <div class="section-header">
          <h4>Subscriptions</h4>
        </div>
        <el-divider></el-divider>
  
        <!-- 表格部分 -->
        <el-table :data="subscriptionsData" style="width: 100%">
          <el-table-column prop="product" label="Product" ></el-table-column>
          <el-table-column prop="plan" label="Plan" ></el-table-column>
          <el-table-column prop="price" label="Price" ></el-table-column>
          <el-table-column prop="orderStatus" label="Order Status"></el-table-column>
          <el-table-column prop="billingStatus" label="Billing Status" ></el-table-column>
        </el-table>
      </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: "curriculumIndex-Subscriptions",
    data() {
      return {
        subscriptionsData: [
          {
            product: "Product A",
            plan: "Basic Plan",
            price: "$10/month",
            orderStatus: "Active",
            billingStatus: "Paid",
          },
          {
            product: "Product B",
            plan: "Pro Plan",
            price: "$20/month",
            orderStatus: "Pending",
            billingStatus: "Unpaid",
          },
          {
            product: "Product C",
            plan: "Enterprise Plan",
            price: "$50/month",
            orderStatus: "Canceled",
            billingStatus: "Refunded",
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .content-card {
    padding: 20px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .section-header h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .el-table th {
    font-weight: bold;
    color: #666;
        text-align: left;
  }
  
  .el-table td {
    color: #333;
  }
  </style>